<div class="text-start" *ngIf="userPortfolio">
  <div>
    <h4 class="text-color-theme font-weight-bold">
      <span>{{ "ChangePhoneReq" | translate }}</span>
      <mat-icon class="text-highlight-company-color">phone</mat-icon>
    </h4>

    <p class="text-muted-special font-medium">
      {{ "Change_Phone_Request_Description" | translate }}
    </p>
  </div>

  <form [formGroup]="phoneForm">
    <label class="required form-field-title text-color-theme">
      {{ "phone" | translate }}
    </label>

    <input
      type="text"
      class="form-control"
      formControlName="phoneNumber"
      placeholder="{{ 'phone' | translate }}"
      autocomplete="off"
    />

    <button
      class="my-3 rounded-btn teal-btn"
      [disabled]="phoneForm.invalid || phoneForm.value.phoneNumber === userPortfolio.Phone"
      (click)="submit()">
      {{ 'save' | translate }}
    </button>
  </form>
</div>

<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
